import React from 'react';
import './Contact.css';
import { FaPhone, FaEnvelope } from 'react-icons/fa';

const Contact = () => {
  return (
    <div className="contact-container">

      {/* ── PAGE HEADER ── */}
      <div className="contact-header">
        <span className="contact-eyebrow">Let's Talk</span>
        <h1>Ready to Build Something <em>That Performs?</em></h1>
       
      </div>

  

      {/* ── CONTACT + PAYMENTS GRID ── */}
      <div className="contact-grid">

        {/* Direct Contact */}
        <div className="contact-card">
          <div className="contact-card-label">Get in Touch</div>
          <h2>Reach Me Directly</h2>
       

          {/* <a href="tel:+12896987602" className="contact-item">
            <div className="contact-item-icon">📞</div>
            <div className="contact-item-text">
              <strong>Phone</strong>
              <span>+1 (289) 698-7602</span>
            </div>
          </a> */}

          <a href="mailto:matt@dudigital.ca" className="contact-item">
            <div className="contact-item-icon">✉️</div>
            <div className="contact-item-text">
              <strong>Click Here to Email Me</strong>
              <span>matt@dudigital.ca</span>
            </div>
          </a>
        </div>

      {/* <div className="consult-block">
        <div className="consult-block-inner">
          <div className="consult-block-text">
            <div className="consult-block-tag">Free · No Pitch · 15 Minutes</div>
            <h2>Is Your Website Leaking Sales?</h2>
            <p>
              Book a free 15-minute call and I'll tell you exactly what's holding your site
              back. <strong>120+ businesses fixed. Yours could be next.</strong>
            </p>
          </div>
          <a
            className="btn-bright"
            href="https://calendly.com/mattduarte56/15min"
            target="_blank"
            rel="noopener noreferrer"
          >
            Book My Free Call →
          </a>
        </div>
      </div> */}
        {/* Existing Clients */}
        <div className="contact-card">
          <div className="contact-card-label">Already a Client?</div>
          <h2>Set Up Your Services</h2>
          <p>Use the secure links below to get your hosting and domain sorted.</p>

          <a
            href="https://buy.stripe.com/3cs5l97ykfkResg4gg"
            className="payment-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="payment-item-left">
              <div className="payment-item-icon">🖥️</div>
              <div className="payment-item-text">
                <strong>Set Up Hosting</strong>
                <span>Secure payment via Stripe</span>
              </div>
            </div>
            <span className="payment-arrow">→</span>
          </a>

          <a
            href="https://buy.stripe.com/3cIaEYg13ffnf78f7R9R602"
            className="payment-item"
            target="_blank"
            rel="noopener noreferrer"
          >
            <div className="payment-item-left">
              <div className="payment-item-icon">🌐</div>
              <div className="payment-item-text">
                <strong>Register Your Domain</strong>
                <span>Secure payment via Stripe</span>
              </div>
            </div>
            <span className="payment-arrow">→</span>
          </a>
        </div>

      </div>

    </div>
  );
};

export default Contact;